let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("18TX5")).then(() => parcelRequire('fhOxf'));